import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: "none";
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
`;

// Used for providing space between components
export const SpacerXSmall = styled.div`
  height: 8px;
  width: 8px;
`;

// Used for providing space between components
export const SpacerSmall = styled.div`
  height: 16px;
  width: 16px;
`;

// Used for providing space between components
export const SpacerMedium = styled.div`
  height: 24px;
  width: 24px;
`;

// Used for providing space between components
export const SpacerLarge = styled.div`
  height: 32px;
  width: 120px;
`;
export const StyledButton = styled.button`
padding: 10px;
border-radius: 50px;
border: none;
background-color: white;
padding: 10px;
font-weight: bold;
color: black;
width: 100px;
cursor: pointer;
box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
:active {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
`;


export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: white;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const TextDescription = styled.p`
  color: white;
  font-size: 16px;
  line-height: 1.6;
`;


const mintTileStyle = {
    mintTitle: {
      flexGrow: .1,
      textAlign: 'center',
      color: 'white',
fontFamily: '"Permanent Marker", cursive',
      fontWeight: '400',
      fontSize: '50px'
    },
    supplyTitle: {
      flexGrow: .1,
      textAlign: 'center',
      color: 'white',
fontFamily: '"Permanent Marker", cursive',
      fontSize: '20px'
    },
    mintDetails: {
      textAlign: 'center',
      color: 'white',
fontFamily: '"Permanent Marker", cursive',
      fontSize: '20px'
    },
    faq: {
      bgColor: 'black',
    }
  }
  
  export default mintTileStyle